import React, { useEffect, useRef, useState } from "react"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../HumanResource/Work/Task/styled"
import SvgIcon from "src/components/SvgIcon"
import { Input, Select, DatePicker, message } from "antd"
import { InputSearchStyle } from "../Setting/common/styled"
import STORAGE from "src/lib/storage"
import DepositeWithdrawalTable from "./component/TransactionTable"
import CreateTransactionModal from "./Modal/CreateTransactionModal"

const DepositeWithdrawal = props => {
  const [disableBtn, setDisableBtn] = useState(false)
  const [tab, setTab] = useState("1")
  const [searchTerm, setSearchTerm] = useState("")
  const [openModalCreate, setOpenModalCreate] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [modalMode, setModalMode] = useState("create")
  const [modalOpen, setModalOpen] = useState(false)
  const [refresh, setRefresh] = useState(false)
  // const [statusApproval, setStatusApproval] = useState()
  // const [statusRefuses , setStatusRefuses] = useState()

  const handleOpen = () => setOpenModal(true)
  const handleCancel = () => setOpenModal(false)

  const handleSubmit = data => {
    // console.log("Giao dịch:", data)
    message.success(
      `Tạo giao dịch ${
        data.type === "deposit" ? "nạp tiền" : "rút tiền"
      } thành công!`,
    )
    setOpenModal(false)
  }

  const Tabs = {
    // all: {
    //   type: "all",
    //   name: "Tất cả",
    //   status: "",
    //   // approval:"",
    // },
    // pending: {
    //   type: "0",
    //   name: "Chờ duyệt",
    //   // status: "",
    //   approval:"0",
    // },
    // refuses: {
    //   type: "refuse",
    //   name: "Từ chối",
    //   // status: "",
    //   refuse:"2",
    // },
    deposite: {
      type: "1",
      name: "Nạp tiền",
      status: "1",
      // approval:"",
    },
    withdrawal: {
      type: "2",
      name: "Rút tiền",
      status: "2",
      // approval:"",
    },
    history: {
      type: "history",
      name: "Lịch sử mua hàng",
      status: "history",
      // approval:"",
    },
    package: {
      type: "5",
      name: "Lịch sử mua gói cước",
      status: "5",
      // approval:"",
    },
  }
  const [activeKey, setActiveKey] = useState("deposite")
  const [tabStatus, setTabStatus] = useState(Tabs["deposite"].status)
  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
    // setStatusApproval(Tabs[key].approval)
    // setStatusRefuses(Tabs[key].refuse)
  }
  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("wallet")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              DANH SÁCH NẠP RÚT TIỀN
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("wallet.create_withdrawal") &&
            permissions.includes("wallet.create_deposit") ? (
              <Button btnType="primary1" onClick={handleOpen}>
                Tạo giao dịch
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              <TabsCustom
                onChange={handleChangeTab}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
                destroyInactiveTabPane={true}
              />
            </StyleTabsCustom>

            <DepositeWithdrawalTable
              scroll={{ x: true }}
              tabStatus={tabStatus}
              // statusApproval={statusApproval}
              // statusRefuses={statusRefuses}
              refreshData={refresh}
              setRefresh={setRefresh}
              permissions={permissions}
            />
            <CreateTransactionModal
              open={openModal}
              onCancel={handleCancel}
              onSubmit={handleSubmit}
              refresh={setRefresh}
            />
          </div>
        </ToolBarStyle>
      </WrapperStyle>
    </div>
  )
}

export default DepositeWithdrawal
